import { rand, randNumber } from '@ngneat/falso';

import { CartageListItem } from '../cartage-list-item';

import { MockCartageBase } from './cartage-base.mock';

export class MockCartageListItem extends CartageListItem {
   constructor() {
      super({
         ...new MockCartageBase() as any,
         pieces: randNumber(),
         piecesType: rand([ 'pcs', 'crt' ]),
         weight: randNumber(),
         weightType: rand([ 'lbs', 'kgs' ]),
         chargeTotal: randNumber(),
         currency: 'USD',
      });
   }
}
